import { render, staticRenderFns } from "./ComponentTreePosturas.vue?vue&type=template&id=19b0c8f4"
import script from "./ComponentTreePosturas.vue?vue&type=script&lang=js"
export * from "./ComponentTreePosturas.vue?vue&type=script&lang=js"
import style0 from "./ComponentTreePosturas.vue?vue&type=style&index=0&id=19b0c8f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports